import axiosInstance from '@/store/axios'
import { rejectErrorApi } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    mediaSources ({ commit }, params) {
      return axiosInstance.get('/api/v1/media-sources', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    createMediaSource ({ dispatch }, channel) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/media-sources',
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateMediaSource ({ dispatch }, mediaSource) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/media-sources/${mediaSource.id}`,
        data: mediaSource,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteMediaSource ({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/media-sources/${id}`,
      })
        .then((result) => result.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    mediaSourceFiles ({ commit, state }, data) {
      const params = {}
      return axiosInstance.get(`/api/v1/media-sources/${data.sourceId}/files`, { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getMRSSItem ({ commit, state }, data) {
      const params = {}
      return axiosInstance.get(`/api/v1/media-sources/${data.sourceId}/mrss-item/${data.itemId}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    parseMRSS ({ commit, state }, params) {
      return axiosInstance.get('/api/v1/media-sources/parse', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    mediaSourcesStat ({ commit, state }, params) {
      return axiosInstance.get('/api/v1/media-sources/stat', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    syncMediaSource ({ dispatch }, source) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/media-sources/${source.id}/sync`,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
  },
}
